import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Model_VariableEnvironnement, BaseQueryParams, AbsDSOptionsItems, TYPE_VARIABLE_ENVIRONMENT, SCOPE_VARIABLE_ENVIRONMENT, AbsPaginatedGrid, AbsGrid, Model_VariableEnvironnementUser, Model_Agent } from 'src/app/app.models';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class VariableEnvironmentService {
    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {

    }

    doGetStartupInfosAction() {
        return this._httpClient.get<StartupInfos_VariableEnvironnement>(this._apiService.endPoints.doGetStartupInfosAction_VariableEnvironnement)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }

    doBuildGridAction(filter: QueryParams_VariableEnvironnement = null) {
        let httpParams = new HttpParams();
        Object.keys(filter).forEach(k => httpParams = httpParams.set(k, filter[k]));
        return this._httpClient.get<AbsPaginatedGrid<any>>(this._apiService.endPoints.doBuildGridAction_VariableEnvironnement, {params: httpParams})
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }

    doSaveVariableEnvironmentAction(_item: Model_VariableEnvironnement) {
        return this._httpClient.post<Model_VariableEnvironnement>(this._apiService.endPoints.doSaveVariableEnvironnementAction_VariableEnvironnement, _item)
        .pipe(catchError(error => { console.error(error); return throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'); }));
    }

    doDeleteVariableEnvironnementAction(_id: string) {
        return this._httpClient.post<void>(this._apiService.endPoints.doDeleteVariableEnvironnementAction_VariableEnvironnement + "/" + _id, {})
        .pipe(catchError(error => { console.error(error); return throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'); }));
    }

    doGetVariablesEnvironnementUserByEnvironnementVariable(_nomVariable: string) {
        let httpParams = new HttpParams().set("NOM_VARIABLE", _nomVariable);
        return this._httpClient.get<Model_VariableEnvironnementUser[]>(this._apiService.endPoints.doGetVariablesEnvironnementUserAction_VariableEnvironnementUser, { params: httpParams })
        .pipe(catchError(error => { console.error(error); return throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'); }));
    }

    doGetVariablesEnvironnementUserByAgent(_agentId: string) {
        let httpParams = new HttpParams().set("AGENT_ID", _agentId);
        return this._httpClient.get<Model_VariableEnvironnementUser[]>(this._apiService.endPoints.doGetVariablesEnvironnementUserAction_VariableEnvironnementUser, { params: httpParams })
        .pipe(catchError(error => { console.error(error); return throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'); }));
    }

    doReinitVariableEnvironnementUser(_variableEnvironnementUserId: string) {
        return this._httpClient.post<Model_VariableEnvironnementUser>(this._apiService.endPoints.doReinitVariablesEnvironnementUserAction_VariableEnvironnementUser + '/' + _variableEnvironnementUserId, { })
        .pipe(catchError(error => { console.error(error); return throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'); }));
    }

}

export class QueryParams_VariableEnvironnement extends BaseQueryParams {
    TYPE_FILTER: number = TYPE_VARIABLE_ENVIRONMENT.ALL;
    SCOPE_FILTER: number = SCOPE_VARIABLE_ENVIRONMENT.ALL;

    constructor() {
        super();
        this.OrderByColumn = "NOM_VARIABLE"
    }
}

export class QueryParams_VariableEnvironnementUser extends BaseQueryParams {
    SYNCED?: boolean; 
}

export class QueryParams_LogVariableEnvironnementUser extends BaseQueryParams {
    NOM_VARIABLE: string;
    AGENT_ID: string;
    SYNCED?: boolean; 
}

export class StartupInfos_VariableEnvironnement { 
    AGENTS: Model_Agent[] = [];
}

export const TYPE_FILTER_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_VARIABLE_ENVIRONMENT.ALL, mDISPLAY_MEMBER: "Tous" },
    { mVALUE_MEMBER: TYPE_VARIABLE_ENVIRONMENT.TEXT, mDISPLAY_MEMBER: "Texte" },
    { mVALUE_MEMBER: TYPE_VARIABLE_ENVIRONMENT.NUMBER, mDISPLAY_MEMBER: "Numérique" },
    { mVALUE_MEMBER: TYPE_VARIABLE_ENVIRONMENT.NUMBER_CURRENCY, mDISPLAY_MEMBER: "Numérique Montant" },
    { mVALUE_MEMBER: TYPE_VARIABLE_ENVIRONMENT.DATETIME, mDISPLAY_MEMBER: "Date" },
];


export const SCOPE_FILTER_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: SCOPE_VARIABLE_ENVIRONMENT.ALL, mDISPLAY_MEMBER: "Tous" },
    { mVALUE_MEMBER: SCOPE_VARIABLE_ENVIRONMENT.PRIVATE, mDISPLAY_MEMBER: "Privé" },
    { mVALUE_MEMBER: SCOPE_VARIABLE_ENVIRONMENT.PUBLIC, mDISPLAY_MEMBER: "Publique" },
];

